module.exports = __webpack_public_path__ + "media/bgm.2f32a095.mp3";